export class Provider {
    get campaign() {
        return null;
    }
    get currentUrl() {
        return null;
    }
    get medium() {
        return null;
    }
    get originDetails() {
        return null;
    }
    get pageProduct() {
        return null;
    }
    get conversionPixels() {
        return null;
    }
    get pageLocation() {
        return null;
    }
    get source() {
        return null;
    }
    get visitId() {
        return null;
    }
    get visitTimestamp() {
        return null;
    }
    get visitorId() {
        return null;
    }
    get visitorTimestamp() {
        return null;
    }
    get viewId() {
        return null;
    }
    get isCustomer() {
        return null;
    }
    get fingerprint() {
        return null;
    }
    get referralCode() {
        return null;
    }
}
